import classes from "./PurchaseSuccess.module.scss";
import React, { useContext, useEffect, useState } from "react";
import checkTitle from "./../../../assets/images/check_title.svg";
import shoppingCart from "./../../../assets/images/shopping_cart_checked.svg";
import paymentCalendar from "./../../../assets/images/payment_calendar.svg";
import paymentCreditCard from "./../../../assets/images/payment_credit_card.svg";
import paymentFile from "./../../../assets/images/payment_file.svg";
import paymentHourglass from "./../../../assets/images/payment_hourglass.svg";
import CardTouch from "../../UI/Card/CardTouch/CardTouch";
import SystemContext from "../../../context/SystemContext";
import { useDispatch, useSelector } from "react-redux";
import useFetch from "../../../hooks/useFetch";
import axios from "axios";
import { API_PDF_CALL, API_URL_GET_ORDER } from "../../../constants/api";
import * as kApi from "../../../constants/api";
import { PROD } from "../../../constants/defaults";
import { useTranslation } from "react-i18next";
import PaymentProcessing from "../PaymentArea/Flow/Payment/PaymentProcessing/PaymentProcessing"
const PurchaseSuccess = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { PixResponse, PurchaseInfo, setPurchaseInfo, clearTagLocal, setNeedUpdateSession, updateTagUser, changePropertyUrl } = useContext(SystemContext);
  const payload = useSelector((state) => state.purchase);
  const isProd = kApi.GET_PROD_OR_DEV === PROD;
  const [OrderStatus, , , fetchOrderStatus] = useFetch({
    autoInit: false,
  });
  const [options, setOptions] = useState(false);
  const [OrderId, setOrderId] = useState();
  const [callPdf, setCallPdf] = useState(true);
  const [timeoutOrderStatus, setTimeoutOrderStatus] = useState(null);
  const [timeoutPDF, setTimeoutPDF] = useState(null);
  const [callNextCharge, setCallNextCharge] = useState(true);


  function dateToYMD(date, separator) {
    date = new Date(date);
    var d = date.getDate();
    var m = date.getMonth() + 1;
    var y = date.getFullYear();
    let result =
      "" +
      (d <= 9 ? "0" + d : d) +
      separator +
      (m <= 9 ? "0" + m : m) +
      separator +
      y;
    return result.toString();
  }

  const NextChargePayment =
    PurchaseInfo.MethodChosen === "CreditCard" ||
      PurchaseInfo.MethodChosen === "OldCards"
      ? t("purchase.next_bill")
      : t("purchase.maturity");

  const PaymentMethod =
    PurchaseInfo.MethodChosen === "CreditCard" ||
      PurchaseInfo.MethodChosen === "OldCards"
      ? t("purchase.credit_card")
      : PurchaseInfo.MethodChosen === "DescPix"
        ? t("purchase.pix")
        : null;

  const MapTextPeriodicity = { "monthly": t("purchase.monthly"), "annual": t("purchase.annual"), "lifetime": t("purchase.lifetime") }
  const Periodicity = (payload.planInfo.periodicity in MapTextPeriodicity) ? MapTextPeriodicity[payload.planInfo.periodicity] : ""

  useEffect(() => {
    setOrderId(
      PurchaseInfo?.MethodChosen === "DescPix"
        ? PixResponse?.order_last_id
        : PixResponse?.order_id
    );
  }, [PixResponse]);

  useEffect(() => {
    if (OrderId && PixResponse && PurchaseInfo?.MethodChosen === "DescPix") {
      setNeedUpdateSession(true)
      callApiPDF(10)

      // Envia tag COMPROU_QUIZ se a compra via PIX foi do plano 24 (treino personalizado)
      const PIX_PURCHASE_PLAN_ID = 24;
      const productIds = payload?.PostData?.product_id || [];
      if (productIds.includes(PIX_PURCHASE_PLAN_ID)) {
        updateTagUser(['COMPROU_QUIZ']);
      }
    }
  }, [OrderId, PixResponse, payload, updateTagUser]);

  useEffect(() => {
    if (PixResponse) {
      setTimeoutOrderStatus(setTimeout(() => {
        fetchOrderStatus({
          url: API_URL_GET_ORDER(
            PurchaseInfo.MethodChosen === "DescPix"
              ? PixResponse.order_last_id
              : PixResponse.order_id
          ),
          method: "GET",
          onSuccess: (res) => {
            setCallPdf(!callPdf);
            dispatch({
              type: "PURCHASE",
              LastPayment: {
                paymentMethod: PaymentMethod,
                periodicity: Periodicity,
                nextCharge: dateToYMD(res.next_charge, "/"),
              },
            });
          },
          onError: () => {
            setCallNextCharge(!callNextCharge);
          },
        });
      }, 4000));
    }
  }, []);

  const timeOutSeconds = PurchaseInfo.MethodChosen === "DescPix" ? 10000 : 4000;
  const retryFetchOrderStatus = (retries) => {
    if (PurchaseInfo.SuccessState == "processing" && retries > 0 && OrderStatus?.status === "AP") {
      setTimeoutOrderStatus(setTimeout(() => {
        // console.log("FetchOrderStatus");
        fetchOrderStatus({
          url: API_URL_GET_ORDER(
            PurchaseInfo.MethodChosen === "DescPix"
              ? PixResponse.order_last_id
              : PixResponse?.order_id
          ),
          method: "GET",
          onError: () => {
            retryFetchOrderStatus(retries - 1);
          },
        });
      }, timeOutSeconds));
    }
  };

  useEffect(() => {
    const mapStatusOrder =
    {
      "AP": () => {
        // console.log("fetchOrderStatus", OrderStatus);
        if (OrderStatus?.count_reject_order && OrderStatus?.count_reject_order > 0) {
          clearTimeout(timeoutPDF)
          clearTimeout(timeoutOrderStatus)
          dispatch({
            type: "PURCHASE",
            purchase: {
              message: "Compra recusada Cartao",
              content: "PaymentArea",
              step: "PaymentError",
            },
          });
        } else {
          retryFetchOrderStatus(10);
        }
      },
      "EX": () => {
        clearTimeout(timeoutPDF)
        clearTimeout(timeoutOrderStatus)
        dispatch({
          type: "PURCHASE",
          purchase: {
            message: "Compra recusada",
            content: "PaymentArea",
            step: "PaymentError",
          },
        });
      },
      "PG": () => {
        clearTimeout(timeoutOrderStatus)
        setPurchaseInfo({
          ...PurchaseInfo,
          "SuccessState": "processed"
        })
        setNeedUpdateSession(true)
        console.log("Compra concluida com sucesso : [processed]")

        // Envia tag COMPROU_QUIZ se a compra foi do plano 24 (treino personalizado)
        const PIX_PURCHASE_PLAN_ID = 24;
        const productIds = payload?.PostData?.product_id || [];
        if (productIds.includes(PIX_PURCHASE_PLAN_ID)) {
          updateTagUser(['COMPROU_QUIZ']);
        }

        callApiPDF(10)
        // dispatch({
        //   type: "RESET_PURCHASE",
        // });
      }
    }
    console.log("OrderStatus", OrderStatus);

    if (PurchaseInfo.SuccessState == "processing" && OrderStatus?.status && OrderStatus?.status in mapStatusOrder) {
      mapStatusOrder[OrderStatus.status]()
    }
  }, [OrderStatus, PurchaseInfo.SuccessState]);

  const callApiPDF = (retries) => {
    if (OrderId) {
      const urlToCall = API_PDF_CALL(OrderId, payload?.PostData.sub);
      axios
        .get(urlToCall, {
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/pdf',
            'Accept': 'application/pdf'
          }
        })
        .then((res) => {
          if (res.status !== 200) {
            if (retries > 0) {
              retryApiCallPDF(retries - 1);
              return;
            }
          }
          const blobUrl = window.URL.createObjectURL(res.data);

          setOptions(blobUrl);
        })
        .catch((errors) => {
          setOptions(false);
          retryApiCallPDF(retries - 1);
        });
    }
  }
  const retryApiCallPDF = (retries) => {
    if (retries > 0) {
      setTimeoutPDF(setTimeout(() => callApiPDF(retries - 1), 4000));
    }
  };


  function pixel() {
    const dataobj = JSON.stringify({
      data: [
        {
          event_name: "Purchase",
          event_time: Math.floor(+new Date() / 1000),
          action_source: "website",
          event_source_url: window.location.href,
          user_data: {
            em: [
              "7b17fb0bd173f625b58636fb796407c22b3d16fc78302d79f0fd30c2fc2fc068",
            ],
            ph: [null],
            client_user_agent: null,
            client_ip_address: null,
          },
          custom_data: {
            currency: "USD",
            value: 39.9,
          },
        },
      ],
    });
    if (isProd) {
      fetch(kApi.API_PIXEL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: dataobj,
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          console.log(JSON.stringify(data));
        });
    }
  }
  useEffect(() => {
    pixel();
    clearTagLocal()
    return () => {
      // console.log("state stateOrder",PurchaseInfo.SuccessState)
      if (PurchaseInfo.SuccessState === "processed") {
        setPurchaseInfo({
          ...PurchaseInfo,
          "SuccessState": "sessionUpdated"
        })
        setNeedUpdateSession(true)

        // console.log("update session")
        // global.updateSession(false)
      }
    }
  }, []);

  useEffect(() => {
    if (PurchaseInfo.SuccessState === "processed") {
      changePropertyUrl("", { etapa: "sucesso" });
      const parseBRL = (val) => {
        if (typeof val === "number") return val;
        const str = String(val).replace(/[R$\s]/g, "");
        if (/,\d{1,2}$/.test(str)) {
          return parseFloat(str.replace(/\./g, "").replace(",", "."));
        }
        return parseFloat(str.replace(/,/g, ""));
      };
      const planValue = parseBRL(payload.planInfo.value);
      window.dataLayer.push({
        event: "purchase",
        ecommerce: {
          transaction_id: OrderId,
          value: planValue,
          currency: "BRL",
          items: [
            {
              item_id: payload.PostData.product_id,
              item_name: payload.planInfo.planName,
              price: planValue,
              quantity: 1
            }
          ]
        }
      });
    } else {
      changePropertyUrl("", { etapa: "processando" });
    }
  }, [PurchaseInfo.SuccessState])

  return PurchaseInfo.SuccessState === "processing" ? (<PaymentProcessing />) : (
    <div className={classes.PurchaseSuccessContent}>
      <div className={classes.Title}>
        <img className={classes.Image} src={checkTitle} alt="" />
        {t("purchase.completed_successfully")}
      </div>
      <div className={classes.SubTitle}>{t("purchase.enjoy_activities")}</div>
      <img className={classes.CardLeft} src={shoppingCart} alt="" />

      <CardTouch
        onClick={() =>
          options && window.open(options, '_blank')
        }
        classPrimary={classes.CardRight}
      >
        <div className={classes.TitleCard}>{payload.planInfo.planName}</div>
        <div className={classes.PaymentMethod}>
          <img src={paymentCreditCard} alt="paymentCalendar" />
          {t("purchase.payment")} <b>{PaymentMethod}</b>
        </div>
        {payload.planInfo.periodicity !== "lifetime" && (<><div className={classes.NextPayment}>
          <img src={paymentCalendar} alt="paymentCalendar" />{" "}
          {NextChargePayment}{" "}
          <b>
            {PurchaseInfo.MethodChosen === "DescPix"
              ? dateToYMD(payload.planInfo.orderStatusPix, "/")
              : OrderStatus?.next_charge &&
              dateToYMD(OrderStatus?.next_charge, "/")}
          </b>
        </div>
          <div className={classes.Recurrence}>
            <img src={paymentHourglass} alt="paymentCalendar" />{" "}
            {t("purchase.frequency")}
            <b> {Periodicity}</b>
          </div></>)}
        <div className={classes.Invoice}>
          <img src={paymentFile} alt="" />
          {options
            ? t("purchase.open_invoice")
            : t("purchase.generating_invoice")}
        </div>
      </CardTouch>

      <div className={classes.BuyAdd}>{t("purchase.boost_plan")}</div>
    </div>
  );
};
export default PurchaseSuccess;
